import { selectorFamily } from 'recoil'
import { IAccount, isUser, IUser, UserId } from '../types/types'
import { usersState } from './users-state'
import { api } from '../utils/api'

export const userState = selectorFamily<IUser | null, UserId | undefined>({
  key: 'userState',
  get:
    (userId) =>
    ({ get }) => {
      if (!userId) {
        return null
      }

      const users = get(usersState)

      return users.find((item) => item.id === userId) || null
    },
  set:
    (userId) =>
    ({ set, get }, newValue) => {
      const prevState = get(usersState)

      const index = prevState.findIndex((user) => user.id === userId)
      if (isUser(newValue)) {
        prevState[index] = newValue

        set(usersState, prevState)
      }
    },
})